export default "__VITE_PUBLIC_ASSET__66862e94__"